(function () {

    'use strict';

    angular.module('iban', [])
        .provider('iban', IbanProvider);

    IbanProvider.$inject = [
        '$windowProvider'
    ];
    function IbanProvider($windowProvider) {
        var $window = $windowProvider.$get();

        return {
            $get: function () {
                return $window.IBAN || {};
            }
        };
    }
})();
